'use client';

import { initLogger } from 'logger';
import { useEffect } from 'react';

export const LoggerInit = () => {
  useEffect(() => {
    initLogger({ service: 'blender' });
  }, []);

  return null;
};
